import React from "react";

interface AvatarProps {
  children: React.ReactNode;
  className?: string;
}

interface AvatarImageProps {
  src: string;
  alt: string;
}

interface AvatarFallbackProps {
  children: React.ReactNode;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ children, className = "" }) => {
  return (
    <div
      className={`relative inline-flex rounded-full overflow-hidden ${className}`}
    >
      {children}
    </div>
  );
};

export const AvatarImage: React.FC<AvatarImageProps> = ({ src, alt }) => {
  return (
    <img
      src={src}
      alt={alt}
      className="w-full h-full object-cover"
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  );
};

export const AvatarFallback: React.FC<AvatarFallbackProps> = ({
  children,
  className = "",
}) => {
  return (
    <div
      className={`w-full h-full bg-brand-secondary flex items-center justify-center text-brand-primary font-medium ${className}`}
    >
      {children}
    </div>
  );
};
